<template>
	<div class="adsAddCustomer">
		<div class="sub-header">
			<div class="input-div">
				<b-form-input
					:placeholder="$t('customer name')"
					class="input-search"
					v-model="searchText"
				></b-form-input>
				<b-dropdown class="menu-dropdown" v-model="order_by" no-flip>
					<template v-slot:button-content>
						<span>
							{{ $t('sort by') }}
						</span>
					</template>
					<b-dropdown-item
						value="LastCreatedAd"
						@click="order_by = 'LastCreatedAd'"
						>{{ $t('latest') }}</b-dropdown-item
					>
					<b-dropdown-item
						value="LastStartDateAd"
						@click="order_by = 'LastStartDateAd'"
						>{{ $t('Advertising time') }}</b-dropdown-item
					>
					<b-dropdown-item
						value="MaxTotalBudget"
						@click="order_by = 'MaxTotalBudget'"
						>{{ $t('total budget') }}</b-dropdown-item
					>
				</b-dropdown>

				<b-button class="add-customer primary" @click="openAddCustomer">
					<IconUserPlus />
					{{ $t('add customer list') }}
				</b-button>
			</div>
		</div>
		<div class="content-div">
			<div class="customer-list-row">
				<b-card
					no-body
					class="mb-1"
					v-for="(customer, index) in customerArray"
					v-bind:key="index"
				>
					<b-button v-b-toggle="'customer-accordion-' + customer.id">
						<div class="list-header">
							<div class="customer-name">{{ customer.name }}</div>
							<div class="customer-ads-expired">
								{{ $t('expire') }} ({{ customer.advertismentsInactive }})
							</div>
							<div class="customer-ads-active">
								{{ $t('Advertising') }}
								<span>({{ customer.advertismentsActive }})</span>
							</div>
							<div class="customer-ads-all">
								{{ $t('all') }}
								<span>({{ customer.advertismentsTotal }})</span>
							</div>
						</div>
						<span class="when-opened" style="margin-left: 11px;">
							<ChevronUpIcon />
						</span>
						<span class="when-closed" style="margin-left: 11px;">
							<ChevronDownIcon />
						</span>
					</b-button>

					<b-collapse
						:id="'customer-accordion-' + customer.id"
						accordion="my-accordion"
						role="tabpanel"
					>
						<b-card-body>
							<div class="customer-details-div">
								<div class="first-div">
									<p>{{ $t('address') }} :</p>
									<p>
										{{ customer.address }}
									</p>
								</div>
								<div class="second-div">
									<p>{{ $t('Contact') }} :</p>
									<p>{{ $t('phone') }} : {{ customer.phone_number }}</p>
									<p>
										{{ $t('Email') }} : <span>{{ customer.email }}</span>
									</p>
								</div>
								<div class="action-div">
									<span @click="openUpdateCustomerDialog(customer)">
										<IconEdit />
									</span>
									<span @click="deleteCustomer(customer.id, customer.name)">
										<IconTrash />
									</span>
								</div>
							</div>

							<div class="ads-history" v-if="customerAdsArray.length">
								<div class="ads-history-header">
									<div>{{ $t('Advertising history') }}</div>
									<div>{{ $t('duration') }}</div>
									<div>{{ $t('price') }}</div>
								</div>
								<div
									class="ads-history-details"
									v-for="(ads, index) in customerAdsArray"
									v-bind:key="index"
								>
									<div
										class="ads-name"
										@click="openAnalyticDialog(ads.id, customer.name)"
										:class="ads.active ? 'active' : ''"
									>
										{{ ads.advertisment_location.short_name }} -
										{{ ads.advertisment_location.width }}*{{
											ads.advertisment_location.height
										}}
									</div>
									<div :class="ads.active ? 'active' : ''">
										{{
											ads.start_date
												| formatDate($router.currentRoute.params.lang)
										}}
										<span v-if="ads.end_date">-</span
										>{{
											ads.end_date
												| formatDate($router.currentRoute.params.lang)
										}}
									</div>
									<div :class="ads.active ? 'active' : ''">
										{{ ads.price.toLocaleString('th-TH') }}
										{{ $t('baht') }}
									</div>
								</div>
							</div>
							<div class="total-div" v-if="customerAdsArray.length">
								<div>{{ $t('included') }}</div>
								<div>
									{{
										customer.totalPrice != null
											? customer.totalPrice.toLocaleString('th-TH')
											: 'No Ads'
									}}
									{{ $t('baht') }}
								</div>
							</div>
							<b-row cols="12" lg="12" class="text-center paginate-position">
								<div class="overflow-auto wrap-pagination d-none d-md-block">
									<b-pagination-nav
										v-model="customerPage"
										class="paginate-item"
										:prev-text="$t('nextPg')"
										:next-text="$t('prevPg')"
										base-url="#"
										:number-of-pages="
											customerPageInfo && customerPageInfo.pageCount
												? customerPageInfo.pageCount
												: 1
										"
									></b-pagination-nav>
								</div>
							</b-row>
						</b-card-body>
					</b-collapse>
				</b-card>
			</div>
		</div>
		<b-row cols="12" lg="12" class="text-center paginate-position">
			<div class="overflow-auto wrap-pagination d-none d-md-block">
				<b-pagination-nav
					v-model="page"
					class="paginate-item"
					:prev-text="$t('nextPg')"
					:next-text="$t('prevPg')"
					:link-gen="paginationNumber"
					:number-of-pages="
						pageInfo && pageInfo.pageCount ? pageInfo.pageCount : 1
					"
					use-router
				></b-pagination-nav>
			</div>
		</b-row>
		<!-- MODAL -->
		<div class="model-div">
			<b-modal
				id="modal-add-customer"
				dialog-class="add-customer-dialog"
				size="md"
				centered
				hide-footer
				hide-header
				style="width:560px"
			>
				<b-container fluid>
					<div class="dialog-header">
						<label>{{ $t('add customer list') }}</label>
						<div @click="closeAddCustomer" class="close-modal">
							<CloseIcon />
						</div>
					</div>
					<b-row class="mb-1 text-center" style="margin: 10px;" v-if="false">
						<div class="wrapper">
							<b-spinner label="Loading..." variant="primary"></b-spinner>
						</div>
					</b-row>
					<b-form
						class="needs-validation"
						novalidate
						id="form-add-address"
						@submit.prevent="
							openDialogForEdit ? updateCustomer() : addCustomer()
						"
					>
						<div class="wrapper">
							<b-form-group>
								<b-row>
									<div class="form-group">
										<b-form-input
											:placeholder="$t('customer name')"
											class="input-search price-input"
											v-model="companyName"
											id="companyName"
											:class="{ 'is-invalid': $v.companyName.$error }"
										></b-form-input>
										<b-form-invalid-feedback
											>Please enter Company name</b-form-invalid-feedback
										>
									</div>
									<div class="form-group">
										<b-form-input
											:placeholder="$t('contact name')"
											class="input-search price-input"
											v-model="contactPersonName"
											id="contactPersonName"
											:class="{ 'is-invalid': $v.contactPersonName.$error }"
										></b-form-input>
										<b-form-invalid-feedback
											>Please enter Company contact
											person</b-form-invalid-feedback
										>
									</div>
								</b-row>

								<div class="form-group">
									<label>{{ $t('address') }}</label>
									<b-form-textarea
										:placeholder="$t('address')"
										class="input-search price-input"
										v-model="address"
										id="address"
										:class="{ 'is-invalid': $v.address.$error }"
									></b-form-textarea>
									<b-form-invalid-feedback
										>Please enter Company address</b-form-invalid-feedback
									>
								</div>
								<b-row>
									<div class="form-group">
										<label>{{ $t('phone number') }}</label>
										<b-form-input
											:placeholder="$t('phone number')"
											class="input-search price-input"
											v-model="phoneNumber"
											id="phoneNumber"
											:class="{ 'is-invalid': $v.phoneNumber.$error }"
										></b-form-input>
										<b-form-invalid-feedback
											>Please enter Company phone
											number</b-form-invalid-feedback
										>
									</div>
									<div class="form-group">
										<label>{{ $t('Email') }}</label>
										<b-form-input
											:placeholder="$t('Email')"
											class="input-search price-input"
											v-model="email"
											id="email"
											:class="{ 'is-invalid': $v.email.$error }"
										></b-form-input>
										<b-form-invalid-feedback
											>Please enter Company email</b-form-invalid-feedback
										>
									</div>
								</b-row>
							</b-form-group>
						</div>
						<div class="wrap-btn-send">
							<b-button class="cancel" id="cancel" @click="closeAddCustomer">{{
								$t('bill.cancel')
							}}</b-button>
							<b-button
								class="btn-send success-button"
								id="save"
								type="submit"
								:disabled="loading"
								v-if="!openDialogForEdit"
								>{{ $t('bill.save') }}</b-button
							>
							<b-button
								class="btn-send success-button"
								id="update"
								type="submit"
								:disabled="loading"
								v-else
								>Update</b-button
							>
						</div>
					</b-form>
				</b-container>
			</b-modal>
			<b-modal
				id="modal-analytics"
				dialog-class="modal-analytics"
				size="lg"
				centered
				hide-footer
				hide-header
			>
				<b-container fluid>
					<div class="dialog-header">
						<h3>{{ customerName }}</h3>
						<div @click="closeAnalyticDialog" class="close-modal">
							<CloseIcon />
						</div>
					</div>
					<div class="analytics-sub-header">
						<div class="date-pickers">
							<div class="text">{{ $t('duration') }}</div>
							<datepicker
								class="date-input"
								:language="th"
								v-model="dateFrom"
								@selected="
									selectedAnalytics = null;
									chartData.datasets = [];
								"
								:disabledDates="disabledDates"
							></datepicker>
							<div class="text">{{ $t('paymentHistory.to') }}</div>
							<datepicker
								class="date-input"
								:language="th"
								v-model="dateTo"
								@selected="
									selectedAnalytics = null;
									chartData.datasets = [];
								"
								:disabledDates="disabledDates"
							></datepicker>
							<b-dropdown class="menu-dropdown" v-model="group_by" no-flip>
								<template v-slot:button-content>
									<span>
										{{ group_by }}
										<ChevronDownIcon />
									</span>
								</template>

								<b-dropdown-item
									value="Week"
									@click="
										group_by = 'Week';
										selectedAnalytics = null;
										chartData.datasets = [];
									"
									>Week</b-dropdown-item
								>
								<b-dropdown-item
									value="Day"
									@click="
										group_by = 'Day';
										selectedAnalytics = null;
										chartData.datasets = [];
									"
									>Day</b-dropdown-item
								>
								<b-dropdown-item
									value="Month"
									@click="
										group_by = 'Month';
										selectedAnalytics = null;
										chartData.datasets = [];
									"
									>Month</b-dropdown-item
								>
							</b-dropdown>
						</div>
						<div class="button-div">
							<b-button class="btn" @click="openEmailDialog"
								><IconMail
							/></b-button>
							<b-button class="btn" @click="downloadReport"
								><IconDownload
							/></b-button>
						</div>
					</div>
					<div class="analytics-sub-header-radio">
						<b-form-radio
							name="radio-size"
							class="firstRadio"
							size="md"
							v-model="selectedAnalytics"
							value="impressions"
							@change="getImpressions()"
							checked
							>{{ $t('impression') }}</b-form-radio
						>
						<b-form-radio
							name="radio-size"
							class="secondRadio"
							size="md"
							v-model="selectedAnalytics"
							value="click"
							@change="getClick()"
							>{{ $t('banner click') }}</b-form-radio
						>
						<b-form-radio
							name="radio-size"
							class="thirdRadio"
							size="md"
							v-model="selectedAnalytics"
							value="ctr"
							@change="getCtr()"
							>{{ $t('click-per-impression rate') }}</b-form-radio
						>
					</div>
					<div class="body" v-if="chartData.datasets.length && !loading">
						<LineChart
							:chartData="chartData"
							:options="chartOptions"
							:width="760"
							:height="380"
						/>
					</div>
				</b-container>
			</b-modal>
			<b-modal
				id="modal-analytics-email-dialog"
				dialog-class="modal-analytics"
				size="md"
				centered
				hide-footer
				hide-header
			>
				<b-container fluid>
					<h3>{{ customerName }}</h3>
					<b-form-input
						:placeholder="$t('Email')"
						class="input-search price-input"
						v-model="reportEmail"
						id="email"
						:class="{ 'is-invalid': !reportEmail }"
					></b-form-input>
					<b-form-invalid-feedback v-if="!reportEmail"
						>Please enter Company email</b-form-invalid-feedback
					>
					<div class="button-div mt-3">
						<b-button
							class="btn-send success-button"
							id="update"
							type="submit"
							@click="sendReport"
							:disabled="loading || !reportEmail"
							>Send</b-button
						>
					</div>
				</b-container>
			</b-modal>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
const moment = require('moment');
import { en, th } from 'vuejs-datepicker/dist/locale';
import { required, email, integer, minLength } from 'vuelidate/lib/validators';
import Datepicker from 'vuejs-datepicker';
import LineChart from '@/plugins/LineChart';

// Icons
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue';
import ChevronUpIcon from 'vue-material-design-icons/ChevronUp.vue';
import IconUserPlus from '@/components/icons/IconUserPlus/index';
import IconEdit from '@/components/icons/IconEdit/index';
import IconTrash from '@/components/icons/IconTrash/index';
import CloseIcon from 'vue-material-design-icons/Close.vue';
import IconMail from '@/components/icons/IconMail';
import IconDownload from '@/components/icons/IconDownload';

export default {
	components: {
		LineChart,
		Datepicker,
		IconUserPlus,
		CloseIcon,
		ChevronDownIcon,
		ChevronUpIcon,
		IconEdit,
		IconTrash,
		IconMail,
		IconDownload
	},
	data() {
		return {
			reportEmail: null,
			companyName: null,
			contactPersonName: null,
			address: null,
			phoneNumber: null,
			email: null,
			loading: false,
			openCustomer: true,
			page: this.$route.params.id ? this.$route.params.id : 1,
			pageInfo: { take: 10, itemCount: 0, page: 1, pageCount: 0 },
			customerPage: 1,
			customerPageInfo: { take: 10, itemCount: 0, page: 1, pageCount: 0 },
			customerArray: [],
			customerAdsArray: [],
			searchText: '',
			order_by: 'LastCreatedAd',
			customerId: null,
			openDialogForEdit: false,
			awaitingSearch: false,
			adsId: null,
			customerName: null,
			en: en,
			th: th,
			dateFrom: new Date(new Date().setFullYear(new Date().getFullYear() - 1)),
			dateTo: new Date(),
			disabledDates: {
				to: new Date(new Date().setFullYear(new Date().getFullYear() - 1)), // Disable all dates up to specific date
				from: new Date() // Disable all dates after specific date
			},
			group_by: 'Week',
			selectedAnalytics: null,
			chartOptions: {
				responsive: false,
				maintainAspectRatio: false,
				scales: {
					gridLines: {
						display: true
					},
					yAxes: [
						{
							id: 'line-one',
							type: 'linear',
							position: 'left'
						}
					]
				},
				legend: {
					labels: {
						generateLabels: function(chart) {
							return '';
						}
					}
				}
			},
			chartData: {
				labels: [],
				datasets: []
			}
		};
	},
	filters: {
		formatDate(value, lang) {
			if (!value) return;
			let now = moment(new Date());
			let newVal = moment(value);
			// if(now.isSame(newVal, 'day')) return
			return moment(value)
				.local('th')
				.format('DD MMM YYYY');
		},
		formatHour(value, lang) {
			if (!value) return;
			return moment(value)
				.local('th')
				.format('HH:mm');
		}
	},
	watch: {
		searchText: function(val) {
			this.loading = true;
			this.page = 1;
			if (!this.awaitingSearch) {
				setTimeout(() => {
					this.getListOfCustomer(true);
					this.awaitingSearch = false;
				}, 1000); // 1 sec delay
			}
			this.awaitingSearch = true;
		},
		order_by: function(val) {
			this.loading = true;
			this.page = 1;
			if (!this.awaitingSearch) {
				setTimeout(() => {
					this.getListOfCustomer(true);
					this.awaitingSearch = false;
				}, 1000); // 1 sec delay
			}
			this.awaitingSearch = true;
		},
		page: function(val) {
			this.getListOfCustomer();
		},
		customerPage: function(val) {
			this.getListOfAdsOfCustomer(false);
		},
		group_by: function(val) {
			if (this.selectedAnalytics == 'impressions') {
				this.getImpressions();
			} else if (this.selectedAnalytics == 'click') {
				this.getClick();
			} else if (this.selectedAnalytics == 'ctr') {
				this.getCtr();
			}
		}
	},
	validations: {
		companyName: { required, min: minLength(2) },
		contactPersonName: { required, min: minLength(2) },
		address: { required, min: minLength(2) },
		phoneNumber: { required, min: minLength(2) },
		email: { required, min: minLength(2), email }
	},
	mounted() {
		this.getListOfCustomer(true);
		if (this.$router.history.current.name == 'AdsAddCustomer') {
			this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
				if (isJustShown) {
					if (this.customerId != collapseId.match(/\d+/g).map(Number)[0]) {
						this.customerId = collapseId.match(/\d+/g).map(Number)[0];
						this.getListOfAdsOfCustomer(true);
					}
				}
			});
		}
		this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
			if (modalId == 'modal-analytics') {
				this.adsId = null;
				this.customerName = null;
				this.chartData = {
					labels: [],
					datasets: []
				};
			}
		});
	},
	methods: {
		...mapActions('AdsController', [
			'GET_LIST_OF_CUSTOMER',
			'GET_LIST_ADS_OF_CUSTOMER',
			'CREATE_CUSTOMER',
			'UPDATE_CUSTOMER',
			'DELETE_CUSTOMER',
			'GET_IMPRESSIONS',
			'GET_CLICK',
			'GET_CTR',
			'GENERATE_ADS_REPORT',
			'SEND_ADS_REPORT'
		]),
		openAddCustomer() {
			this.$bvModal.show('modal-add-customer');
		},
		closeAddCustomer() {
			var vm = this;
			vm.customerId = null;
			vm.openDialogForEdit = false;
			this.$bvModal.hide('modal-add-customer');
		},
		async addCustomer() {
			var vm = this;
			vm.loading = true;
			vm.$v.$touch();
			if (vm.$v.$error) {
				vm.loading = false;
				return;
			}
			await this.CREATE_CUSTOMER({
				name: vm.companyName,
				contact_name: vm.contactPersonName,
				address: vm.address,
				email: vm.email,
				phone_number: vm.phoneNumber
			})
				.then(data => {
					vm.loading = false;
					this.closeAddCustomer();
					this.getListOfCustomer(true);
					this.$bvToast.toast('Customer Added', {
						title: 'Customer Added',
						variant: 'success',
						solid: true
					});
				})
				.catch(err => {
					vm.loading = false;
					this.$bvToast.toast(err, {
						title: 'Customer Added',
						variant: 'error',
						solid: true
					});
				});
		},
		async updateCustomer() {
			var vm = this;
			vm.loading = true;
			vm.$v.$touch();
			if (vm.$v.$error) {
				vm.loading = false;
				return;
			}
			await this.UPDATE_CUSTOMER({
				name: vm.companyName,
				contact_name: vm.contactPersonName,
				address: vm.address,
				email: vm.email,
				phone_number: vm.phoneNumber,
				id: vm.customerId
			})
				.then(data => {
					vm.loading = false;
					this.closeAddCustomer();
					this.getListOfCustomer(true);
					this.$bvToast.toast('Customer Updated', {
						title: 'Customer Update',
						variant: 'success',
						solid: true
					});
				})
				.catch(err => {
					vm.loading = false;
					this.$bvToast.toast(err, {
						title: 'Customer Updated',
						variant: 'error',
						solid: true
					});
				});
		},
		openUpdateCustomerDialog(customer) {
			var vm = this;
			vm.companyName = customer.name;
			vm.contactPersonName = customer.contact_name;
			vm.address = customer.address;
			vm.email = customer.email;
			vm.phoneNumber = customer.phone_number;
			vm.customerId = customer.id;
			vm.openDialogForEdit = true;
			vm.openAddCustomer();
		},
		funcSubString(string, number) {
			let subStr = '';
			if (string.length > number && string.indexOf(' ') !== -1) {
				subStr =
					string.substring(0, string.substring(0, number).lastIndexOf(' ')) +
					' ...';
			} else {
				subStr = string;
			}
			return subStr.toString();
		},
		async deleteCustomer(customerId, customerName) {
			await this.$swal({
				title: this.$t('you want to delete'),
				text: this.funcSubString(customerName, 30),
				customClass: {
					container: 'swal-del-item'
				},
				showCancelButton: true,
				confirmButtonColor: 'var(--projectPrimaryColor)',
				cancelButtonColor: '#DC3849',
				confirmButtonText: this.$t('cancel'),
				cancelButtonText: this.$t('delete')
			}).then(result => {
				if (result.dismiss == 'cancel') {
					this.DELETE_CUSTOMER({ id: customerId })
						.then(data => {
							this.getListOfCustomer(false);
							vm.customerId = null;
							this.$bvToast.toast('Customer deleted', {
								title: 'Customer deleted',
								variant: 'success',
								solid: true
							});
						})
						.catch(err => {
							vm.loading = false;
							vm.customerId = null;
							this.$bvToast.toast(err, {
								title: 'Customer deleted',
								variant: 'error',
								solid: true
							});
						});
				}
			});
		},
		async getListOfCustomer(filterd) {
			var vm = this;
			vm.loading = true;
			if (filterd) {
				vm.page = 1;
			}
			await this.GET_LIST_OF_CUSTOMER({
				order_by: vm.order_by,
				name: vm.searchText ? vm.searchText : '',
				page: vm.page
			}).then(result => {
				vm.customerArray = result.data;
				vm.pageInfo = result.meta;
				vm.loading = false;
			});
		},
		async getListOfAdsOfCustomer(filterd) {
			var vm = this;
			vm.loading = true;
			if (filterd) {
				vm.customerPage = 1;
				vm.customerAdsArray = [];
			}
			await this.GET_LIST_ADS_OF_CUSTOMER({
				id: vm.customerId,
				page: vm.customerPage
			})
				.then(result => {
					vm.customerAdsArray = result.data;
					vm.customerPageInfo = result.meta;
					vm.loading = false;
				})
				.catch(err => {
					vm.loading = false;
				});
		},
		paginationNumber(pageNum) {
			return pageNum === 1 ? '?page=1' : `?page=${pageNum}`;
		},
		customerPaginationNumber(pageNum) {
			return pageNum === 1
				? (this.customerPage = 1)
				: (this.customerPage = pageNum);
		},
		getTotal(arra) {
			let total = 0;
			arra.forEach(element => {
				total = total + element.price;
			});
			return total;
		},
		openAnalyticDialog(adsId, customerName) {
			this.adsId = adsId;
			this.customerName = customerName;
			this.$bvModal.show('modal-analytics');
		},
		closeAnalyticDialog() {
			this.adsId = null;
			this.customerName = null;
			this.chartData = {
				labels: [],
				datasets: []
			};
			this.$bvModal.hide('modal-analytics');
		},

		async getImpressions() {
			if (!this.group_by) {
				this.$bvToast.toast('Try again!', {
					title: 'Select Groupd By ',
					variant: 'error',
					solid: true
				});
				return;
			}
			this.loading = true;
			await this.GET_IMPRESSIONS({
				id: this.adsId,
				from: moment(this.dateFrom).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
				to: moment(this.dateTo).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
				group_by: this.group_by
			})
				.then(data => {
					this.loading = false;
					this.chartData.labels = data.data.labels;
					this.chartData.datasets = [
						{
							data: data.data.values
						}
					];
				})
				.catch(err => {
					this.loading = false;
				});
		},
		async getClick() {
			if (!this.group_by) {
				this.$bvToast.toast('Try again!', {
					title: 'Select Groupd By ',
					variant: 'error',
					solid: true
				});
				return;
			}
			this.loading = true;
			await this.GET_CLICK({
				id: this.adsId,
				from: moment(this.dateFrom).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
				to: moment(this.dateTo).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
				group_by: this.group_by
			})
				.then(data => {
					this.loading = false;
					this.chartData.labels = data.data.labels;
					this.chartData.datasets = [
						{
							data: data.data.values
						}
					];
				})
				.catch(err => {
					this.loading = false;
				});
		},
		async getCtr() {
			if (!this.group_by) {
				this.$bvToast.toast('Try again!', {
					title: 'Select Groupd By ',
					variant: 'error',
					solid: true
				});
				return;
			}
			this.loading = true;
			await this.GET_CTR({
				id: this.adsId,
				from: moment(this.dateFrom).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
				to: moment(this.dateTo).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
				group_by: this.group_by
			})
				.then(data => {
					this.loading = false;
					this.chartData.labels = data.data.labels;
					this.chartData.datasets = [
						{
							data: data.data.values
						}
					];
				})
				.catch(err => {
					this.loading = false;
				});
		},
		downloadReport() {
			if (!this.group_by) {
				this.$bvToast.toast('Try again!', {
					title: 'Select Groupd By ',
					variant: 'error',
					solid: true
				});
				return;
			}
			var vm = this;
			vm.loading = true;
			this.GENERATE_ADS_REPORT({
				id: this.adsId,
				from: moment(this.dateFrom).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
				to: moment(this.dateTo).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
				group_by: this.group_by
			})
				.then(result => {
					var fileURL = window.URL.createObjectURL(new Blob([result.data]));
					var fileLink = document.createElement('a');
					fileLink.href = fileURL;
					fileLink.setAttribute('download', 'report_ads.pdf');
					document.body.appendChild(fileLink);
					fileLink.click();
					vm.loading = false;
				})
				.catch(err => {
					vm.loading = false;
				});
		},
		openEmailDialog() {
			this.$bvModal.show('modal-analytics-email-dialog');
		},
		sendReport() {
			if (!this.group_by) {
				this.$bvToast.toast('Try again!', {
					title: 'Select Groupd By ',
					variant: 'error',
					solid: true
				});
				return;
			}
			this.SEND_ADS_REPORT({
				id: this.adsId,
				from: moment(this.dateFrom).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
				to: moment(this.dateTo).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
				email: this.reportEmail,
				group_by: this.group_by
			})
				.then(data => {
					this.$bvToast.toast('Report sent!', {
						title: 'Ads Reports',
						variant: 'success',
						solid: true
					});
				})
				.catch(error => {
					this.$bvToast.toast('Try again!', {
						title: 'Ads Reports',
						variant: 'error',
						solid: true
					});
				});
		}
	}
};
</script>

<style lang="scss">
@import 'adsAddCustomer.scss';
</style>
